"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class InjectContainer {
    constructor() {
        this.set = (name, instance) => {
            this.injectData.set(name, instance);
        };
        this.has = (name) => {
            return this.injectData.has(name) || this.depInitRegister.has(name);
        };
        this.register = (name, clazz, ...args) => {
            this.depInitRegister.set(name, { clazz, args });
        };
        this.get = (name) => {
            if (!this.injectData.has(name) && this.depInitRegister.has(name)) {
                try {
                    this.depInit(name);
                }
                catch (ex) {
                    throw ex;
                }
            }
            return this.injectData.get(name);
        };
        this.init = (name, clazz, ...args) => {
            const instance = new clazz(...args);
            this.set(name, instance);
            return instance;
        };
        this.depInit = (name, depStack) => {
            if (this.injectData.has(name)) {
                return;
            }
            if (!depStack) {
                depStack = [name];
            }
            else if (depStack.indexOf(name) !== -1) {
                throw new Error(`dependencies error, cyclic dependence: ${name},` + depStack.join(','));
            }
            else {
                depStack.push(name);
            }
            const registerData = this.depInitRegister.get(name);
            if (!registerData) {
                const error = new Error(`dependence  clazz ${name} not found`);
                error.name = `clazzNotFound:${name}`;
                throw error;
            }
            const registerClass = registerData.clazz;
            if (!registerClass.depClass) {
                return this.init(name, registerData.clazz, ...registerData.args);
            }
            else {
                registerClass.depClass.forEach((depName) => {
                    this.depInit(depName, depStack);
                });
                return this.init(name, registerData.clazz, ...registerData.args);
            }
        };
        this.injectData = new Map();
        this.depInitRegister = new Map();
    }
}
exports.InjectContainer = InjectContainer;
const injectContainer = new InjectContainer();
function proxy(target) {
    return new Proxy(target, {
        get(currentTarget, name) {
            try {
                if (typeof name === 'string') {
                    return name in currentTarget ? currentTarget[name] : injectContainer.get(name);
                }
                else {
                    return currentTarget[name];
                }
            }
            catch (ex) {
                return currentTarget[name];
            }
        },
    });
}
exports.proxy = proxy;
exports.default = injectContainer;
//# sourceMappingURL=data:application/json;base64,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